import React from 'react'

import { mq } from 'marketing-site/src/library/utils'
import { IProps } from './index'
import { GridContainer } from 'marketing-site/src/mvp-v2/library/components/GridContainer'
import classNames from 'classnames'
import kebabCase from 'lodash.kebabcase'

export const IconGrid: React.FC<IProps> = ({
  layout = '3-3',
  eyebrow,
  title,
  subhead,
  cta,
  items,
  theme = 'none',
  backgroundColor = 'transparent',
}) => {
  const classes = classNames('icon-grid', {
    [`mvp-background-color-${kebabCase(backgroundColor)}`]: backgroundColor,
    [`icon-grid--theme-${theme}`]: title && theme !== 'none',
  })

  return (
    <>
      <div className={classes} data-testid="icon-grid">
        <GridContainer
          layout={layout}
          eyebrow={eyebrow}
          title={title}
          titleSize="heading-2"
          subhead={subhead}
          cta={cta}
          ctaPosition="below-header"
          body={items}
          bodyAlignment="start"
          bodyColumnGap="default"
          bodyRowGap="default"
          theme={theme}
          backgroundColor={backgroundColor}
        />
      </div>

      <style jsx>
        {`
          .icon-grid {
            &--theme-blue-gradient {
              background: linear-gradient(
                180deg,
                rgba(196, 224, 254, 0) 0%,
                rgba(196, 224, 254, 0.5) 18.5%,
                rgba(196, 224, 254, 0) 37%
              );
            }

            :global(.grid-container) {
              padding-bottom: 0;
              padding-top: 0;
            }
            :global(.grid-container .grid-container__body) {
              grid-row-gap: 2rem;
            }
          }

          @media (${mq.tablet}) {
            .icon-grid {
              &--theme-blue-gradient {
                background: linear-gradient(
                  180deg,
                  rgba(196, 224, 254, 0) 0%,
                  rgba(196, 224, 254, 0.5) 22%,
                  rgba(196, 224, 254, 0) 44%
                );
              }
            }
          }

          @media (${mq.desktop}) {
            .icon-grid {
              &--theme-blue-gradient {
                background: linear-gradient(
                  180deg,
                  rgba(196, 224, 254, 0) 0%,
                  rgba(196, 224, 254, 0.5) 28.25%,
                  rgba(196, 224, 254, 0) 56.5%
                );
              }
            }
          }
        `}
      </style>
    </>
  )
}
